import $ from 'jquery'

$(function () {
  if ($('body').hasClass('test')) {
    window.confirm = function () {
      return true
    }
  }
})
